import { render, staticRenderFns } from "./sysModuleList.vue?vue&type=template&id=5c8252ea&scoped=true"
import script from "./sysModuleList.vue?vue&type=script&lang=js"
export * from "./sysModuleList.vue?vue&type=script&lang=js"
import style0 from "./sysModuleList.vue?vue&type=style&index=0&id=5c8252ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8252ea",
  null
  
)

export default component.exports